import { axiosRequestConfig } from '@apis/common';
import { getConfig } from '@utils/config';
import axios from 'axios';

export const fetchBarcode = async (d2dNo: string) => {
  const response = await axios.get(
    `${getConfig().serverUrl}/label/barcode/${d2dNo}`,
    axiosRequestConfig(),
  );
  return response.data;
};

export const fetchQrcode = async (d2dNo: string) => {
  const response = await axios.get(
    `${getConfig().serverUrl}/label/qrcode/${d2dNo}`,
    axiosRequestConfig(),
  );
  return response.data;
};

export const fetchDashboardBarcode = async (d2dNo: string) => {
  const response = await axios.get(
    `${getConfig().serverUrl}/dashboard/label/barcode/${d2dNo}`,
    axiosRequestConfig(),
  );
  return response.data;
};

export const fetchDashboardQrcode = async (d2dNo: string) => {
  const response = await axios.get(
    `${getConfig().serverUrl}/dashboard/label/qrcode/${d2dNo}`,
    axiosRequestConfig(),
  );
  return response.data;
};
